import React from "react";
import { Link } from "react-router-dom";

import { loginPath } from "../../../managerStore";

import styles from "./MultiFactorAuthenticationForm.module.scss";

export interface MultiFactorAuthenticationFormProps {
  calling: boolean;
  error: string;
  onSubmit: (mfa_code: string) => void;
}

const validates: { [key: string]: (value: any) => string } = {};

validates["mfa_code"] = val => {
  return val.mfa_code.trim() ? "" : "この項目は入力が必須です。";
};

export const MultiFactorAuthenticationForm = (
  props: MultiFactorAuthenticationFormProps,
) => {
  const [state, setState] = React.useState({
    mfa_code: "",
    isSubmitted: false,
    errorMessages: {} as { [key: string]: string },
  });

  const onSubmit = React.useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      const errorMessages = {} as { [key: string]: string };
      Object.keys(validates).forEach(key => {
        const ret = validates[key](state);
        if (ret) {
          errorMessages[key] = ret;
        }
      });
      if (Object.keys(errorMessages).length > 0) {
        setState(s => ({ ...s, errorMessages }));
        return;
      }
      props.onSubmit(state.mfa_code.trim());
    },
    [state, props],
  );

  const onChange = React.useCallback(
    (e: React.SyntheticEvent<HTMLInputElement>) => {
      e.preventDefault();
      const val = e.currentTarget.value;
      const key = e.currentTarget.name;
      const args = { [key]: val };
      const ret = validates[key](args);
      setState(prevState => ({
        ...prevState,
        [key]: val,
        errorMessages: { ...prevState.errorMessages, [key]: ret },
      }));
    },
    [],
  );

  return (
    <div className="container mt-3">
      <div className={styles.pageTitle}>
        ENAGEEDサービス学校管理者画面
        <br />
        ログインページ
      </div>
      <div className={styles.inputAreaWrapper}>
        <form
          onSubmit={onSubmit}
          className={state.isSubmitted ? "was-validated" : ""}
        >
          {props.error && (
            <div className={styles.errorBillboard}>{props.error}</div>
          )}
          <div className="mb-3">
            <label className="form-label" htmlFor="mfa_code">
              認証コード
            </label>
            <div className="input-group">
              <input
                type="mfa_code"
                name="mfa_code"
                className={
                  "form-control " +
                  (state.errorMessages["mfa_code"]
                    ? "is-invalid"
                    : state.mfa_code
                    ? "is-valid"
                    : "")
                }
                id="mfa_code"
                value={state.mfa_code}
                onChange={onChange}
              />
              <div className="invalid-feedback">
                {state.errorMessages["mfa_code"]}
              </div>
            </div>
          </div>
          <button
            className="btn btn-primary"
            onClick={onSubmit}
            disabled={
              props.calling ||
              Object.keys(state.errorMessages).filter(
                k => state.errorMessages[k],
              ).length > 0
            }
          >
            ログイン
          </button>
        </form>
        <div className="mt-3">
          <Link to={loginPath} className={styles.backToLogin}>
            ログイン画面に戻る
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MultiFactorAuthenticationForm;
